import * as React from "react";
import { useAuthContext } from "../../../auth/AuthProvider";
import { useDispatch, useSelector } from "react-redux";
import * as UserDetailsAction from "../../../stores/user/UserDetailsAction";
import * as BasketAction from "../../../stores/basket/BasketAction";
import { useSnackbar } from "notistack";
import ToastStatusEnum from "../../../constants/ToastStatusEnum";
import { isProductProhibitedForUser } from "../../views/productOverview/ProductHelper";
import { findProductByName } from "../../views/productOverview/ProductHelper";
import localStorage from "../../../utilities/localStorage";


export const LocalStorageProducts: React.FunctionComponent = (
) => {
    const authContext = useAuthContext();
    const userId = authContext?.user?.id;
    const dispatch = useDispatch();
    const userDetails = useSelector(state => state.userDetails?.currentlyLoggedUser);
    const { enqueueSnackbar } = useSnackbar();
    const productsInfo = useSelector(state => state.products);

    const basketItemsFromLs = (localStorage as any).getJsonItem("basket", null);
    React.useEffect(() => {
        if (userId) {
            dispatch(UserDetailsAction.requestCurrentUser(userId));
        }
    }, [dispatch, userId]);

    React.useEffect(() => {
        if (userDetails && productsInfo?.products) {
            const prohibitedProducts = basketItemsFromLs?.items?.filter((item: any) => {
                const product = findProductByName(productsInfo?.products, item.product);
                return isProductProhibitedForUser(product, userDetails);
            });

            prohibitedProducts?.forEach(p => {
                const product = findProductByName(productsInfo?.products, p.product);
                enqueueSnackbar(
                    `Product "${product.name}" could not be added to the basket because it is not available in your region.`,
                    { variant: ToastStatusEnum.Error }
                );
            });
            dispatch(BasketAction.addItemsFromLocalStorageToDatabase(userId)).then(res => {
                BasketAction.requestBasket(userId);
            });
        }
    // eslint-disable-next-line
    }, [userDetails, productsInfo]);

    return null;
};
